// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1Z_4w","content":"RecentSearches_content__2R7V3"};